import React from 'react';
import PropTypes from 'prop-types';
import TargetModalFooter from 'apps/personal/components/targets-personal-target-modal-footer';
import Query from 'library/util/query';
import TargetWorkflowAddTargets from 'apps/personal/components/target-workflows/add-targets';
import { resolve } from 'library/helpers/path-resolver';

const CreateTarget = async ({ name, text }) => {
  const query = `mutation {
    create_target_grouping_skills_engine(name: '${name}', text: '${text}') {
      target_grouping {
        id
        name
        match
      }
    }
  }`;

  return await Query(query, null, {cancelToken: null});
}

class TargetWorkflowDescription extends React.PureComponent {
  static propTypes = {
    close: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
  }

  state = {
    step: 2,
    industry: '',
    name: '',
    description: '',
    target: null,
    creatingTarget: false
  }

  nextStep = () => {
    return this.setState({step: this.state.step + 1});
  }

  prevStep = () => {
    return this.setState({step: this.state.step - 1});
  }

  handleChange = ({ target }) => {
    const { name, value } = target;
    const newState = {};
    newState[name] = value;

    return this.setState(newState);
  }

  handleFormSubmit = async () => {
    this.setState({creatingTarget: true});

    const createTarget = await CreateTarget({name: this.state.name, text: this.state.description});
    const nextStep = this.state.step += 1;
    const newTarget = resolve(createTarget, 'data/create_target_grouping_skills_engine/target_grouping');

    return this.setState({
      target: newTarget,
      step: nextStep,
      creatingTarget: false
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className='modal-header'>
          <h1>Enter A Job Description</h1>
          <a onClick={this.props.close} href="javascript:void(0)">×</a>
        </div>
        {this.state.step == 2 &&
          <React.Fragment>
            <div className='personal-target-modal-body'>
              <form onSubmit={this.handleFormSubmit} className="personal-target-job-description-form">
                <div className="personal-target-job-description-form-section">
                  <label>
                    {trans`Position Name`}
                    <input type="text" name="name" placeholder={trans`Position Name`} onChange={this.handleChange} value={this.state.name} required />
                  </label>
                  <label>
                    {trans`Industry`}
                    <input type="text" name="industry" placeholder={trans`Industry`} onChange={this.handleChange} value={this.state.industry} required />
                  </label>
                </div>
                <div className="personal-target-job-description-form-section">
                  <label>
                    {trans`Job Description`}
                    <textarea name='description' placeholder={trans`Job Description`} onChange={this.handleChange} value={this.state.description} required />
                  </label>
                </div>
              </form>
            </div>
            <TargetModalFooter
              current={this.state.step}
              steps={3}
              prev={this.props.reset}
              close={this.props.close}
              next={this.handleFormSubmit}
              nextSaving={this.state.creatingTarget}
            />
          </React.Fragment>
        }
        {this.state.step == 3 &&
          <TargetWorkflowAddTargets
            targets={[this.state.target]}
            close={this.props.close}
            prev={this.prevStep}
            user={this.props.user}
            onComplete={this.props.onComplete}
          />
        }
      </React.Fragment>
    )
  }

}

export default TargetWorkflowDescription
